export const socialLinks = {
  twitter: {
    username: '_g0d13_',
    url: 'https://twitter.com/_g0d13_',
    description: 'Student & Frontend Developer'
  },
  facebook: {
    username: '',
    url: 'https://www.facebook.com/mrLuisFer/',
    description: ''
  },
  linkedin: {
    username: 'Juan Diego Parra',
    url: 'https://www.linkedin.com/in/g0d13/',
    description: 'Frontend Developer | React & NodeJs'
  },
  reddit: {
    username: '',
    url: '',
    description: ''
  },
  github: {
    username: 'g0d13',
    url: 'https://github.com/g0d13',
    description: '⚛ making every line count'
  },
  twitch: {
    username: '',
    url: '',
    description: ''
  },
  portfolio: {
    username: '',
    url: '',
    description: ''
  },
  behance: {
    username: '',
    url: '',
    description: ''
  },
  instagram: {
    username: 'g0k137u72021',
    url: 'https://www.instagram.com/g0k137u72021/',
    description: ''
  },
  cv: {
    username: '',
    url: '',
    description: ''
  }
}
